/* eslint-disable jsx-a11y/no-onchange */
/** @jsx jsx */
import { bool, string, node, number, func } from 'prop-types'
import { jsx, Label, Flex } from 'theme-ui'
import { useField } from 'formik'
import './formInputs.css'
import { HelperText, ErrorMessage } from './Common'
import MaskedInput from 'react-text-mask'

const PhoneInput = ({
  label,
  removeMargin,
  inputWidth = '100%',
  errorMessage,
  ...props
}) => {
  // const { ref } = useIMask(opts)
  const [field, meta] = useField(props)
  const phoneNumberMask = [
    '(',
    /[1-9]/,
    /\d/,
    /\d/,
    ')',
    ' ',
    /\d/,
    /\d/,
    /\d/,
    '-',
    /\d/,
    /\d/,
    /\d/,
    /\d/,
  ]

  return (
    <Flex sx={{ mb: removeMargin ? 0 : 5, flexDirection: 'column' }}>
      <Label htmlFor={props.name}>{label}</Label>
      <HelperText>{props.helperText}</HelperText>
      <Flex>
        <MaskedInput
          sx={{
            mb: removeMargin ? 0 : 2,
            width: inputWidth,
            bg:
              meta.touched && meta.error
                ? 'inputError'
                : !meta.error && meta.value
                ? 'inputSuccess'
                : 'inputBackground',
            boxSizing: 'border-box',
            mx: 0,
            mt: 0,
            minWidth: 0,
            display: 'block',
            padding: '8px',
            appearance: 'none',
            border: 'none',
            borderRadius: 'none',
            height: '50px',
          }}
          mask={phoneNumberMask}
          {...field}
          {...props}
        />
      </Flex>
      {meta.touched && (meta.error || errorMessage) ? (
        <ErrorMessage>{meta.error ? meta.error : errorMessage}</ErrorMessage>
      ) : null}
    </Flex>
  )
}
PhoneInput.propTypes = {
  buttonDisabled: bool,
  buttonIcon: node,
  buttonText: string,
  handleIconClick: func,
  helperText: string,
  label: string.isRequired,
  maxLength: number,
  name: string.isRequired,
  removeMargin: bool,
  inputWidth: string,
  errorMessage: string,
}

export default PhoneInput
